import { useCommunityContext } from 'providers';
import { useMemo } from 'react';

import { formatISO8601Date } from '@jebel/utils';

import {
  MemberCommunitySidebarItemsQueryVariables,
  useMemberCommunitySidebarItemsQuery,
} from 'shared/graphql';

type Options = Omit<Parameters<typeof useMemberCommunitySidebarItemsQuery>[0], 'variables'> & {
  variables?: Omit<MemberCommunitySidebarItemsQueryVariables, 'now' | 'community'>;
};

export function useMemberCommunitySidebarItems(options?: Options) {
  const { selectedCommunity } = useCommunityContext();

  const now = useMemo(() => formatISO8601Date(), []);

  const variables = useMemo(() => {
    const variables: MemberCommunitySidebarItemsQueryVariables = {
      ...options?.variables,
      now,
      community: selectedCommunity?.id,
    };

    return variables;
  }, [options?.variables, selectedCommunity?.id]);

  const { data, loading } = useMemberCommunitySidebarItemsQuery({
    ...options,

    skip: !selectedCommunity?.id || options?.skip,
    variables,
  });

  const birthdays = data?.birthdays?.items || [];
  const events = data?.events?.items || [];

  return {
    birthdays,
    events,
    loading,
  };
}
